<template>
  <!-- <div class="wscn-http404-container">
    <div class="wscn-http404">
      <div class="pic-404">
        <img class="pic-404__parent" src="@/assets/images/404_images/404.png" alt="404">
        <img class="pic-404__child left" src="@/assets/images/404_images/404_cloud.png" alt="404">
        <img class="pic-404__child mid" src="@/assets/images//404_images/404_cloud.png" alt="404">
        <img class="pic-404__child right" src="@/assets/images/404_images/404_cloud.png" alt="404">
      </div>
      <div class="bullshit">
        <div class="bullshit__info">请检查您输入的网址是否正确或联系系统管理员处理</div>
        <a href="/" class="bullshit__return-home">返回首页</a>
      </div>
    </div>
  </div> -->
  <div class="page">
    <Header :showHeaderSearch="this.isShowSearch()" :isShowBanner="false" />
    <div class="banner">
      <img src="@/assets/images/address.png" alt="" />
    </div>
    <div class="landing-header">
      <div class="landing-header-info">
        <div class="header-info-title ">您访问的网址已过期</div>
        <div class="header-info-desc">为避免无法访问</div>
        <div class="header-info-desc">请将收藏夹网址更换为</div>
        <div class="header-info-desc" style="margin-bottom: 40px;">
          www.taogetu.com
        </div>
        <button class="header-info-btn" @click="gotoHome()">
          点击访问最新网址，Ctrl+D收藏
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/header.vue";
import Dialog from "../activity/module/dialog.vue";

export default {
  name: "PageCollect",
  components: { Header, Dialog },
  methods: {
    backToHome() {
      this.$router.push("/materialDownload");
    },
    isShowSearch() {
      let flag = false;
      try {
        if (
          this.$store.state.common.userInfo.blance !== null &&
          this.$store.state.common.userInfo.blance > 0
        ) {
          flag = true;
        } else {
          flag = false;
        }
      } catch (e) {
        flag = false;
      }
      return flag;
    },
    gotoHome() {
      this.$router.push({ path: "/materialDownload" });
      this.$store.commit("asideMenuId", "materialDownload");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.page {
  background: #0e1925;
  width: 100%;
  height: 100%;
  .banner {
    position: absolute;
    top: 66px;
    width: 100vw;
    z-index: 1;
    display: flex;
    justify-content: center;
    img {
      width: 1920px;
      display: block;
      margin-left: 100px;
    }
  }
  .landing-header {
    z-index: 9;
    position: relative;
    width: 1200px;
    height: 727px;
    padding-top: 180px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    .header-info-title {
      font-weight: 600;
      font-size: 48px;
      line-height: 46px;
      color: #ffffffe6;
      margin-bottom: 40px;
    }

    .landing-header-info {
      width: 533px;
      height: 326px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .header-info-desc {
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      color: #fffc;
      margin-bottom: 12px;
    }

    .header-info-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 278px;
      height: 56px;
      background: linear-gradient(94.89deg, #EA4335 20.54%, #06c8e2 102.7%);
      border-radius: 8px;
      outline: none;
      border: none;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #fff;
      cursor: pointer;
    }
  }
  .main {
    position: absolute;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    p {
      font-size: 14px;
      color: #4a4a4a;
      text-align: center;
      margin-top: 12px;
      margin-bottom: 48px;
    }
  }
}
// .wscn-http404-container{
//   transform: translate(-50%,-50%);
//   position: absolute;
//   top: 40%;
//   left: 50%;
// }
// .wscn-http404 {
//   position: relative;
//   width: 1200px;
//   padding: 0 50px;
//   overflow: hidden;
//   .pic-404 {
//     position: relative;
//     float: left;
//     width: 600px;
//     overflow: hidden;
//     &__parent {
//       width: 100%;
//     }
//     &__child {
//       position: absolute;
//       &.left {
//         width: 80px;
//         top: 17px;
//         left: 220px;
//         opacity: 0;
//         animation-name: cloudLeft;
//         animation-duration: 2s;
//         animation-timing-function: linear;
//         animation-fill-mode: forwards;
//         animation-delay: 1s;
//       }
//       &.mid {
//         width: 46px;
//         top: 10px;
//         left: 420px;
//         opacity: 0;
//         animation-name: cloudMid;
//         animation-duration: 2s;
//         animation-timing-function: linear;
//         animation-fill-mode: forwards;
//         animation-delay: 1.2s;
//       }
//       &.right {
//         width: 62px;
//         top: 100px;
//         left: 500px;
//         opacity: 0;
//         animation-name: cloudRight;
//         animation-duration: 2s;
//         animation-timing-function: linear;
//         animation-fill-mode: forwards;
//         animation-delay: 1s;
//       }
//       @keyframes cloudLeft {
//         0% {
//           top: 17px;
//           left: 220px;
//           opacity: 0;
//         }
//         20% {
//           top: 33px;
//           left: 188px;
//           opacity: 1;
//         }
//         80% {
//           top: 81px;
//           left: 92px;
//           opacity: 1;
//         }
//         100% {
//           top: 97px;
//           left: 60px;
//           opacity: 0;
//         }
//       }
//       @keyframes cloudMid {
//         0% {
//           top: 10px;
//           left: 420px;
//           opacity: 0;
//         }
//         20% {
//           top: 40px;
//           left: 360px;
//           opacity: 1;
//         }
//         70% {
//           top: 130px;
//           left: 180px;
//           opacity: 1;
//         }
//         100% {
//           top: 160px;
//           left: 120px;
//           opacity: 0;
//         }
//       }
//       @keyframes cloudRight {
//         0% {
//           top: 100px;
//           left: 500px;
//           opacity: 0;
//         }
//         20% {
//           top: 120px;
//           left: 460px;
//           opacity: 1;
//         }
//         80% {
//           top: 180px;
//           left: 340px;
//           opacity: 1;
//         }
//         100% {
//           top: 200px;
//           left: 300px;
//           opacity: 0;
//         }
//       }
//     }
//   }
//   .bullshit {
//     position: relative;
//     float: left;
//     width: 300px;
//     padding: 30px 0;
//     overflow: hidden;
//     &__oops {
//       font-size: 32px;
//       font-weight: bold;
//       line-height: 40px;
//       color: #1482f0;
//       opacity: 0;
//       margin-bottom: 20px;
//       animation-name: slideUp;
//       animation-duration: 0.5s;
//       animation-fill-mode: forwards;
//     }
//     &__headline {
//       font-size: 20px;
//       line-height: 24px;
//       color: #222;
//       font-weight: bold;
//       opacity: 0;
//       margin-bottom: 10px;
//       animation-name: slideUp;
//       animation-duration: 0.5s;
//       animation-delay: 0.1s;
//       animation-fill-mode: forwards;
//     }
//     &__info {
//       font-size: 13px;
//       line-height: 21px;
//       color: grey;
//       opacity: 0;
//       margin-bottom: 30px;
//       animation-name: slideUp;
//       animation-duration: 0.5s;
//       animation-delay: 0.2s;
//       animation-fill-mode: forwards;
//     }
//     &__return-home {
//       display: block;
//       float: left;
//       width: 110px;
//       height: 36px;
//       background: #1482f0;
//       border-radius: 100px;
//       text-align: center;
//       color: #ffffff;
//       opacity: 0;
//       font-size: 14px;
//       line-height: 36px;
//       cursor: pointer;
//       animation-name: slideUp;
//       animation-duration: 0.5s;
//       animation-delay: 0.3s;
//       animation-fill-mode: forwards;
//     }
//     @keyframes slideUp {
//       0% {
//         transform: translateY(60px);
//         opacity: 0;
//       }
//       100% {
//         transform: translateY(0);
//         opacity: 1;
//       }
//     }
//   }
// }
</style>
